module.exports = __webpack_public_path__ + "img/clothing185.deb58b30.jpg";